export interface SeasonalTask {
  id: string;
  label: string;
}

export interface SeasonalGroup {
  id: string;
  label: string;
  color: string;
  accent: string;
  tasks: SeasonalTask[];
}

export interface SeasonalData {
  title: string;
  emoji: string;
  description: string;
  groups: SeasonalGroup[];
}

export const SEASONAL: SeasonalData = {
  title: "Seasonal Maintenance",
  emoji: "🔄",
  description: "Not every month — but if you stay on top of these, the house basically runs itself.",
  groups: [
    {
      id: "3mo",
      label: "Every 3 Months",
      color: "#f0f8ff",
      accent: "#4a90d4",
      tasks: [
        { id: "s3_1", label: "Replace toothbrushes — whole family" },
        { id: "s3_2", label: "Replace facial cleansing brush head" },
        { id: "s3_3", label: "Clean washing machine drum & door seals" },
        { id: "s3_4", label: "Replace kitchen sponges & scrubbers" },
        { id: "s3_5", label: "Check & rotate pantry staples — discard expired" },
        { id: "s3_6", label: "Shampoo rugs — high traffic areas & toddler play spaces" },
      ],
    },
    {
      id: "6mo",
      label: "Every 6 Months",
      color: "#f5f0ff",
      accent: "#9b6dd4",
      tasks: [
        { id: "s6_1", label: "Replace pillows or wash pillow inserts" },
        { id: "s6_2", label: "Clean dryer vent & do a deep lint trap clean" },
        { id: "s6_3", label: "Flip or rotate mattress" },
        { id: "s6_4", label: "Check first aid kit — restock & discard expired" },
        { id: "s6_5", label: "Test smoke & CO detectors, replace batteries" },
        { id: "s6_6", label: "Car upkeep — oil check, tire pressure & rotation, fluid levels, wiper blades & interior wipe down" },
      ],
    },
  ],
};
